/**
 * ***************************
 * GlobalSubNav Routes in Configuration *
 * ***************************
 */
import auditTrail from './auditTrail';
import billing from './billing';
import oldBilling from './oldBilling';
import emailTemplates from './emailTemplates';
import { mailSynchronisation, mailSyncReport } from './mailSynchronisation';
import organisationDetails from './organisationDetails';
import rolesAndPermissions from './rolesAndPermissions';
import { timeZone, approvalSettings } from './systemSettings';
import usersAndGroups from './usersAndGroups';

/**
 * ***********************
 * Org Routes Components *
 * ***********************
 */
const Main = () => import('@/components/Organisations/OrganisationMain');

export default {
  parent: 'Configuration',
  path: '/configuration',
  name: 'orgMain',
  meta: {
    /**
     * ! Make sure to order permissions same as children(having corresponding permission) order
     * Ex: Inside Childern "organisationDetails", permission defined is can_view_organisation
     * So we have placed can_view_organisation at 1st index in below permission array
     */
    permission: [
      // organisationDetails
      {
        action: 'view',
        entity: 'organisation'
      },
      {
        action: 'view',
        entity: 'child_organisation_details',
        type: 'dynamic'
      },
      // usersAndGroups
      {
        action: 'view',
        entity: 'user_and_groups'
      },
      // rolesAndPermissions
      {
        action: 'view',
        entity: 'system_roles'
      },
      // billing
      {
        action: 'view',
        entity: 'subscription',
      },
      {
        action: 'manage',
        entity: 'subscription',
      },
      {
        action: 'view',
        entity: 'child_subscription',
        type: 'dynamic',
      },
      {
        action: 'manage',
        entity: 'child_subscription',
        type: 'dynamic',
      },
      // oldBilling
      {
        action: 'manage',
        entity: 'system'
      },
      // mailSynchronisation
      {
        action: 'request',
        entity: 'mailsync'
      },
      // emailTemplates
      {
        action: 'view',
        entity: 'email_templates'
      },
      // timeZone
      {
        action: 'manage',
        entity: 'organisation'
      },
      // auditTrail
      {
        action: 'view',
        entity: 'audit_trail'
      },
      // approvalSettings
      {
        action: 'manage',
        entity: 'discovery_approval_setting'
      }
    ],
    redirectionMap: {
      can_view_organisation: '/configuration/overview',
      can_view_child_organisation_details: '/configuration/overview',
      can_view_user_and_groups: '/configuration/users-groups',
      can_view_system_roles: '/configuration/roles',
      can_view_subscription: '/configuration/billing',
      can_manage_subscription: '/configuration/billing',
      can_view_child_subscription: '/configuration/billing',
      can_manage_child_subscription: '/configuration/billing',
      can_request_mailsync: '/configuration/mail-sync/p1',
      can_view_email_templates: '/configuration/email-templates',
      can_manage_organisation: '/configuration/timezone',
      can_view_audit_trail: '/configuration/audit-trail',
      can_manage_discovery_approval_setting: '/configuration/approval-settings'
    },
    validateSomePermissions: true,
    id: 'configuration-tab'
  },
  permission: [
    // organisationDetails
    {
      action: 'view',
      entity: 'organisation'
    },
    {
      action: 'view',
      entity: 'child_organisation_details',
      type: 'dynamic'
    },
    // usersAndGroups
    {
      action: 'view',
      entity: 'user_and_groups'
    },
    // rolesAndPermissions
    {
      action: 'view',
      entity: 'system_roles'
    },
    // billing
    {
      action: 'view',
      entity: 'subscription',
    },
    {
      action: 'manage',
      entity: 'subscription',
    },
    {
      action: 'view',
      entity: 'child_subscription',
      type: 'dynamic',
    },
    {
      action: 'manage',
      entity: 'child_subscription',
      type: 'dynamic',
    },
    // oldBilling
    {
      action: 'manage',
      entity: 'system'
    },
    // mailSynchronisation
    {
      action: 'request',
      entity: 'mailsync'
    },
    // emailTemplates
    {
      action: 'view',
      entity: 'email_templates'
    },
    // timeZone
    {
      action: 'manage',
      entity: 'organisation'
    },
    // auditTrail
    {
      action: 'view',
      entity: 'audit_trail'
    },
    // approvalSettings
    {
      action: 'manage',
      entity: 'discovery_approval_setting'
    }
  ],
  component: Main,
  children: [
    organisationDetails,
    usersAndGroups,
    rolesAndPermissions,
    billing,
    oldBilling,
    mailSynchronisation,
    mailSyncReport,
    emailTemplates,
    timeZone,
    auditTrail,
    approvalSettings
  ]
};
